export default {
    //AcademyComponent
    customization: 'Personalise your academy',
    sections: 'Customisation sections',
    // Secciones del menú lateral: cada descripción nombra solo lo que hay en esa pantalla.
    identity: 'Identity',
    identity_description: 'Name, tagline, logo and favicon',
    design: 'Design',
    design_description: 'Colours and typography',
    home: 'Home page',
    home_description: 'Header, banner and description',
    description_location_help: 'Where it appears: with the "2 Columns, Text + Image" header it is shown next to the image at the top of the home page. With the full size banner headers it is shown in the contact section at the bottom of the home page.',
    menu_section_description: 'Website menu links',
    contact_social: 'Contact and social media',
    contact_description: 'Contact, social media and custom HTML',
    legal_description: 'Privacy and legal notice',
    settings: 'Settings',
    settings_description: 'Domain, language and scripts',
    domain: "Domain",
    brand_logo: "Logo and Brand",
    rrss_contact: "Contact and RRSS",
    legal: "Legal",
    options: 'Options',

    //DomainComponent
    your_domain: "Your domain mybrainspro.com",
    example_1: 'https://',
    example_2: '.mybrainspro.com',
    info_domain: "Type the domain WITHOUT symbols (.,-¿?!-$%&/()...), accents or spaces. You do not need to put www.",
    domain_input: "Domain mybrainspro.com",
    custom_domain: "Custom domain",
    domain_text: 'Domain',
    info_domain2: "Enter your domain (www.yourdomain.com) to use it as your homepage or as a secondary page (youracademy.yourdomain.com).",
    attention: "Attention",
    info_attention: "Only available for ADVANCED and PRO plan.",
    activate_domain: "To activate your domain at BrainsPro: ",
    info_activate_1line: "Visit the platform where you purchased your domain and look for the DNS settings.",
    info_activate_2line: "Adds record type A to IP: 76.223.11.227",
    info_activate_3line: "Please note that it can take up to 48 hours for these changes to take effect and propagate in your DNS. Once ready, you can start using the new address of your BrainsPro online academy.",
    info_activate_4line: "The brainspro team will contact you to send you some additional records that you will have to place in your DNS. With them we will generate your secure website (https://).",
    example_academy: 'academy-example',
    example_domain: 'myacademy.com',
    //LanguageSelector
    lang: 'Language',
    academy_lang: 'Academy Language',
    academy_lang_selector_text: 'Choose the language of your academy',

    //BrandingComponent
    banner: 'Banner',
    brand_academy: "Branding your academy",
    academy_name: "Name of Academy",
    full_name: "Choose the full name of your academy",
    tagline: "Academy tagline",
    slogan: "Choose your academy's slogan",
    tagline_placeholder: "Write your tagline here",
    search: 'Search',
    my_academy: 'My Academy at BrainsPro',
    change: 'Change',
    insert: 'Insert',

    //ContactComponent
    description: "Description",
    web_rrss: "Web and Social Networks",
    web_blog: "Web or Blog",
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    linkedin: "Linkedin",
    youtube: "Youtube",
    location: "Location and Fiscal Data",
    address_line_1: "Address, line 1",
    address_line_2: "Address, line 2",
    postalcode: "Postcode",
    city: "City",
    province: "Province",
    country: "Country",
    company_name: "Company name",
    nif_cif: "TAX ID/CIF",

    //LegalComponent
    privacy_policy: "Privacy Policy",
    text_register: "Summary text for user registration",
    user_view_text: "This text will be displayed in the user registration, as a summary of the longer version that will be displayed on your school's legal notice page.",
    privacy_policy_page: "Privacy Policy Page",
    privacy_policy_academy_page: "Academy Privacy Policy Page",
    legal_notice: "Legal Notice",

    //Contact
    contact_bloq: 'Contact Block',
    html_bloq: 'Inserts an html block to accompany the contact information. Like a google maps iframe.',

    //Branding
    //BannerBrandingComponent
    upload_banner: 'Upload your banner',
    image_format: 'PNG, JPG, GIF up to 3MB',
    banner_size_recommendation: 'Recommended: a wide (panoramic) image, at least 1600×600 px. On small screens it will be shown in full; on large screens it will be cropped to fill the full width.',

    //ColorsComponent
    desing_colors: 'Design and Colours',
    header_type: 'Header type',
    banner_complete: 'Full size banner',
    banner_complete_no_text: 'Full size banner without text',
    columns_text_image: '2 Columns, Text + Image',
    banner_info: 'This will change the type of cover image that users will see in your academy.',
    enterprise_color: 'Corporate colour',
    text_color: 'Text colour',

    //FontsComponent
    desing_fonts: 'Typography',
    fonts_info: 'Choose the font used for each type of text in your academy.',
    font_h1: 'Main title (H1)',
    font_h2: 'Subtitle (H2)',
    font_h3: 'Section title (H3)',
    font_body: 'Body text',
    font_default: 'Default',

    //FaviconComponent
    favicon: 'Favicon',
    favicon_help: 'Icon shown in the browser tab, next to the page title.',
    upload_favicon: 'Upload your favicon',
    favicon_format: 'PNG, JPG, GIF up to 3MB',

    //LogoBrandingComponent
    logo: 'Logo',
    logo_help: 'Shown in the website header and on certificates.',
    upload_logo: 'Upload your logo',

    //OptionsComponent
    register_config: 'Registration Configuration',
    info_button_register: 'Activating this button will deactivate the option to register in the academy. To do so, all users must register from the Brainspro App.',
    restricted_register: 'Registration restriction',

    //MenuComponent
    menu: 'Menu',
    menu_description: "Choose which links appear in the top menu of your academy's website and in what order.",
    menu_default_notice: "You haven't added any items yet, so your website is using the default menu. As soon as you add one, the menu will show only the items in this list.",
    add_menu_item: 'Add item',
    edit_menu_item: 'Edit item',
    menu_item_edit: 'Edit',
    menu_item_type: 'Type',
    menu_item_type_catalog: 'Catalogue',
    menu_item_type_contact: 'Contact',
    menu_item_type_page: 'Page',
    menu_item_type_link: 'Link',
    menu_item_type_home: 'Home',
    menu_item_type_home_help: "Takes visitors to your academy's home page.",
    menu_item_type_catalog_help: 'Takes visitors to the page with all your courses.',
    menu_item_type_contact_help: 'Takes visitors to the contact section of your home page.',
    menu_item_type_link_help: 'Takes visitors to any web address you enter.',
    menu_item_title: 'Link text',
    menu_item_add_translations: 'Add name in other languages',
    menu_item_hide_translations: 'Hide names in other languages',
    menu_item_translations: 'Name in other languages',
    menu_item_translations_example: 'Example: if the link is called "Courses", in Spanish you can write "Cursos".',
    menu_item_page: 'Page',
    menu_item_select_page: 'Choose a page',
    menu_item_page_invalid: "This item's page is no longer available. Choose another one to be able to save.",
    menu_pages_loading: 'Loading pages…',
    menu_pages_error: "The academy's pages could not be loaded.",
    menu_no_pages: "You don't have any pages yet. Write to support and we'll help you create them.",
    menu_page_unavailable: 'Page not available',
    menu_page_unavailable_help: "This item's page no longer exists, so it is not shown on the website. Edit it to choose another one.",
    menu_item_url: 'URL',
    menu_item_url_help: 'It must start with https:// or http://.',
    menu_item_visible: 'Visible on the website',
    menu_item_hidden: 'Hidden',
    move_menu_item_up: 'Move item up',
    move_menu_item_down: 'Move item down',
    drag_menu_item: 'Drag to reorder',
    delete_menu_item: 'Delete menu item',
    delete_menu_item_confirm: '“{title}” will be removed from the menu. This action cannot be undone.',
    menu_item_saved: 'The menu item has been saved',
    menu_item_deleted: 'The item has been removed from the menu',
    menu_order_saved: 'The menu order has been saved',
    menu_order_error: 'The menu order could not be saved. The previous order has been restored.',
    menu_unexpected_error: 'An unexpected error occurred with the menu',
    menu_item_name_es: 'Name in Spanish',
    menu_item_name_en: 'Name in English',
    menu_item_name_ca: 'Name in Catalan',
    menu_item_name_de: 'Name in German',
    menu_item_name_pt: 'Name in Portuguese',


}